import {
  HYBRID_CONSENT_TITLE,
  getHybridConsentText,
  hasHybridConsent,
  recordHybridConsent,
} from '@application/backup/HybridConsent';
import { escapeHtml, issuerName } from '@domain/legal/IssuerInfo';
import { getIssuerInfo } from '@infra/legal/IssuerInfoService';

export async function enforceHybridConsentGate(
  root: HTMLElement,
  tenantId: string,
): Promise<boolean> {
  if (hasHybridConsent(tenantId)) return true;
  return new Promise((resolve) => {
    const overlay = document.createElement('div');
    overlay.className = 'modal-overlay';
    overlay.style.cssText =
      'position:fixed;inset:0;background:rgba(10,18,30,.72);z-index:80;display:flex;align-items:center;justify-content:center;padding:24px;';
    overlay.innerHTML = `
      <div role="dialog" aria-modal="true" style="max-width:560px;background:#fff;color:#0a121e;border-radius:8px;padding:24px;">
        <h2 style="margin:0 0 12px;font-size:18px;">${HYBRID_CONSENT_TITLE}</h2>
        <p style="font-size:14px;line-height:1.55;white-space:pre-wrap;">${escapeHtml(getHybridConsentText())}</p>
        <label style="display:flex;gap:8px;margin:16px 0;font-size:13px;">
          <input type="checkbox" id="hybrid-consent-ok">
          J’accepte l’envoi de la copie de sécurité chiffrée chez ${escapeHtml(issuerName(getIssuerInfo()))}.
        </label>
        <div style="display:flex;gap:8px;justify-content:flex-end;">
          <button type="button" class="btn btn-secondary" id="hybrid-consent-later">Plus tard</button>
          <button type="button" class="btn btn-primary" id="hybrid-consent-yes" disabled>Accepter</button>
        </div>
      </div>`;
    root.appendChild(overlay);
    const box = overlay.querySelector('#hybrid-consent-ok') as HTMLInputElement;
    const yes = overlay.querySelector('#hybrid-consent-yes') as HTMLButtonElement;
    box.addEventListener('change', () => {
      yes.disabled = !box.checked;
    });
    yes.addEventListener('click', () => {
      recordHybridConsent(tenantId);
      overlay.remove();
      resolve(true);
    });
    overlay.querySelector('#hybrid-consent-later')?.addEventListener('click', () => {
      overlay.remove();
      resolve(false);
    });
  });
}
